import React, { useEffect } from 'react';
import { Scale, ShieldAlert, FileWarning, Fingerprint, Globe, ChevronRight, CheckCircle2, Clock } from 'lucide-react';
import Footer from '../../Components/Footer/Footer';
import Navbar from '../../Components/Navbar/Navbar';

const TermsOfUse = () => {

    useEffect(() => {
        document.title = 'ข้อกำหนดการใช้งาน | ราชพฤกษ์ไตเทียม - Terms of Service';
        
        const metaDescription = document.querySelector('meta[name="description"]');
        if (metaDescription) {
            metaDescription.setAttribute('content', 'ข้อกำหนดและเงื่อนไขการใช้บริการเว็บไซต์ศูนย์ฟอกเลือดด้วยเครื่องไตเทียม ราชพฤกษ์ โปรดอ่านและทำความเข้าใจก่อนใช้บริการ');
        }
    }, []);

    const terms = [
        {
            title: "1. การยอมรับข้อกำหนด",
            icon: Scale,
            color: "text-blue-600",
            bgColor: "bg-blue-50",
            borderColor: "border-blue-200",
            content: "การเข้าถึงและใช้งานเว็บไซต์นี้ ถือว่าคุณได้ยอมรับและยินยอมที่จะปฏิบัติตามข้อกำหนดและเงื่อนไขการใช้งานเหล่านี้ รวมถึงนโยบายความเป็นส่วนตัวของเรา หากคุณไม่ตกลงกรุณาระงับการใช้งานเว็บไซต์นี้"
        },
        {
            title: "2. ทรัพย์สินทางปัญญา",
            icon: Fingerprint,
            color: "text-orange-600",
            bgColor: "bg-orange-50",
            borderColor: "border-orange-200",
            content: "เนื้อหาทั้งหมดบนเว็บไซต์นี้ รวมถึงข้อความ รูปภาพ โลโก้ และเครื่องหมายการค้า เป็นทรัพย์สินของศูนย์ไตเทียมราชพฤกษ์ ห้ามมิให้มีการคัดลอก ดัดแปลง หรือนำไปใช้เพื่อวัตถุประสงค์ทางการค้าโดยไม่ได้รับอนุญาตเป็นลายลักษณ์อักษร"
        },
        {
            title: "3. ข้อจำกัดความรับผิดชอบ",
            icon: ShieldAlert,
            color: "text-rose-600",
            bgColor: "bg-rose-50",
            borderColor: "border-rose-200",
            content: "ข้อมูลที่ปรากฏบนเว็บไซต์นี้มีวัตถุประสงค์เพื่อให้ข้อมูลทั่วไปเท่านั้น ไม่สามารถใช้แทนการวินิจฉัยหรือคำแนะนำทางการแพทย์จากพยาบาลหรือแพทย์ผู้เชี่ยวชาญได้โดยตรง โปรดปรึกษาเจ้าหน้าที่ทางการแพทย์ก่อนการตัดสินใจใดๆ"
        },
        {
            title: "4. การใช้งานที่ถูกต้อง",
            icon: Globe,
            color: "text-emerald-600",
            bgColor: "bg-emerald-50",
            borderColor: "border-emerald-200",
            content: "คุณตกลงที่จะไม่ใช้งานเว็บไซต์เพื่อวัตถุประสงค์ที่ผิดกฎหมาย หรือส่งข้อมูลที่มีไวรัส หรือกระทำการใดๆ ที่อาจสร้างความเสียหายต่อระบบซอฟต์แวร์และฮาร์ดแวร์ของเว็บไซต์"
        },
        {
            title: "5. ลิงก์ไปยังเว็บไซต์ภายนอก",
            icon: ChevronRight,
            color: "text-indigo-600",
            bgColor: "bg-indigo-50",
            borderColor: "border-indigo-200",
            content: "เว็บไซต์อาจมีลิงก์ไปยังเว็บไซต์ของบุคคลที่สามเพื่อความสะดวกของคุณ เราไม่มีส่วนรับผิดชอบต่อเนื้อหาหรือนโยบายของเว็บไซต์เหล่านั้น การเข้าชมถือเป็นความเสี่ยงของผู้ใช้งานเอง"
        },
        {
            title: "6. การระงับการเข้าใช้งาน",
            icon: FileWarning,
            color: "text-slate-600",
            bgColor: "bg-slate-50",
            borderColor: "border-slate-200",
            content: "เราขอสงวนสิทธิ์ในการระงับการเข้าถึงเว็บไซต์หรือยกเลิกการให้บริการส่วนใดส่วนหนึ่ง โดยไม่ต้องแจ้งให้ทราบล่วงหน้า หากพบว่ามีการละเมิดข้อกำหนดการใช้งานเหล่านี้"
        }
    ];

    return (
        <div className="min-h-screen bg-gradient-to-br from-slate-50 via-white to-blue-50 font-sans text-slate-900 flex flex-col">
            
            <Navbar />

            <main className="flex-grow pt-32 pb-24 md:pt-40 md:pb-32">
                
                <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8">
                    
                    {/* Header Title Section - Enhanced */}
                    <div className="text-center mb-16 md:mb-20">
                        <div className="inline-flex items-center gap-2 px-4 py-2 mb-6 text-xs font-black tracking-[0.2em] text-orange-600 uppercase bg-orange-100 rounded-full border border-orange-200">
                            <Scale className="w-4 h-4" />
                            Legal Terms
                        </div>
                        <h1 className="text-5xl md:text-6xl lg:text-7xl font-black text-slate-900 mb-6 tracking-tight leading-tight">
                            Terms of <span className="text-transparent bg-clip-text bg-gradient-to-r from-orange-600 to-blue-600">Use</span>
                        </h1>
                        <div className="w-24 h-1.5 bg-gradient-to-r from-orange-600 to-blue-600 rounded-full mx-auto mb-8"></div>
                        <p className="text-slate-600 max-w-3xl mx-auto text-lg md:text-xl font-medium leading-relaxed">
                            โปรดอ่านข้อกำหนดและเงื่อนไขการใช้บริการอย่างละเอียด 
                            เพื่อความเข้าใจในการรับบริการและสิทธิประโยชน์ของคุณ
                        </p>
                    </div>

                    {/* Card Content - Enhanced */}
                    <div className="bg-white rounded-[3rem] shadow-2xl shadow-blue-900/10 p-8 md:p-16 lg:p-20 border-2 border-slate-100 relative overflow-hidden">
                        
                        {/* Decorative background shapes */}
                        <div className="absolute top-0 right-0 w-96 h-96 bg-orange-100 rounded-full -mr-48 -mt-48 opacity-30 blur-3xl"></div>
                        <div className="absolute bottom-0 left-0 w-96 h-96 bg-blue-100 rounded-full -ml-48 -mb-48 opacity-30 blur-3xl"></div>

                        {/* Status Header - Enhanced */}
                        <div className="flex flex-col sm:flex-row items-center justify-between mb-16 pb-10 border-b-2 border-slate-100 gap-6 relative z-10">
                            <div className="flex items-center gap-5 text-center sm:text-left">
                                <div className="p-5 bg-gradient-to-br from-orange-600 to-orange-500 rounded-[2rem] shadow-xl shadow-orange-500/30">
                                    <Scale className="w-10 h-10 text-white" />
                                </div>
                                <div>
                                    <h2 className="text-3xl font-black text-slate-900 tracking-tight">ข้อกำหนดการใช้งาน</h2>
                                    <div className="flex items-center gap-2 mt-2 text-slate-500 font-bold text-xs">
                                        <Clock className="w-3.5 h-3.5" />
                                        <span>อัปเดตล่าสุด: 18 มกราคม 2569</span>
                                    </div>
                                </div>
                            </div>
                            <div className="flex items-center gap-2.5 text-emerald-600 bg-emerald-50 px-5 py-3 rounded-2xl border-2 border-emerald-200 shadow-sm">
                                <CheckCircle2 className="w-5 h-5" />
                                <span className="text-xs font-black uppercase tracking-wider">Official Policy</span>
                            </div>
                        </div>

                        {/* Terms Grid - Enhanced */}
                        <div className="grid grid-cols-1 gap-12 relative z-10">
                            {terms.map((item, index) => (
                                <div key={index} className={`group flex flex-col md:flex-row gap-6 items-start p-6 -m-6 rounded-3xl hover:bg-gradient-to-br hover:from-slate-50 hover:to-orange-50 transition-all duration-500 border-2 border-transparent hover:${item.borderColor}`}>
                                    <div className="md:w-1/3 flex items-start gap-4">
                                        <div className={`shrink-0 p-4 ${item.bgColor} shadow-lg border-2 ${item.borderColor} ${item.color} rounded-2xl group-hover:scale-110 group-hover:-translate-y-1 transition-all duration-500`}>
                                            <item.icon className="w-7 h-7" strokeWidth={2} />
                                        </div>
                                        <h3 className="font-black text-xl md:text-2xl text-slate-900 leading-tight pt-2">{item.title}</h3>
                                    </div>
                                    <div className="md:w-2/3">
                                        <p className="text-slate-600 leading-relaxed text-base md:text-lg font-medium group-hover:text-slate-900 transition-colors">
                                            {item.content}
                                        </p>
                                    </div>
                                </div>
                            ))}
                        </div>

                    </div>

                    {/* Bottom Notice - Enhanced */}
                    <div className="mt-16 p-10 md:p-14 bg-gradient-to-r from-slate-900 via-slate-800 to-slate-900 rounded-[3rem] text-white relative overflow-hidden shadow-2xl shadow-slate-900/30">
                        <div className="absolute inset-0 opacity-20">
                            <div className="absolute top-0 right-0 w-64 h-64 bg-blue-500 rounded-full -mr-32 -mt-32 blur-3xl"></div>
                            <div className="absolute bottom-0 left-0 w-64 h-64 bg-orange-500 rounded-full -ml-32 -mb-32 blur-3xl"></div>
                        </div>
                        <div className="relative z-10 text-center">
                            <h3 className="text-3xl md:text-4xl font-black mb-4 tracking-tight">มีคำถามเพิ่มเติม?</h3>
                            <p className="text-slate-300 mb-8 max-w-2xl mx-auto leading-relaxed text-lg">
                                หากท่านมีข้อสงสัยเกี่ยวกับข้อกำหนดการใช้งาน สามารถติดต่อทีมงานของเราได้ตลอดเวลา
                            </p>
                            <a 
                                href="tel:0811506992"
                                className="inline-block bg-gradient-to-r from-orange-500 to-orange-600 hover:from-orange-600 hover:to-orange-700 text-white px-10 py-4 rounded-2xl font-black transition-all shadow-xl shadow-orange-500/30 active:scale-95"
                            >
                                ติดต่อเรา
                            </a>
                        </div>
                    </div>

                </div>
            </main>

            <Footer />

            {/* SEO Content (Hidden but crawlable) */}
            <div className="sr-only">
                <h2>ข้อกำหนดการใช้งาน ราชพฤกษ์ไตเทียม</h2>
                <p>
                    ข้อกำหนดและเงื่อนไขการใช้บริการเว็บไซต์ศูนย์ฟอกเลือดด้วยเครื่องไตเทียม ราชพฤกษ์ 
                    รวมถึงนโยบายทรัพย์สินทางปัญญา ความรับผิดชอบ และการใช้งานที่ถูกต้อง
                </p>
            </div>

        </div>
    );
};

export default TermsOfUse;
